import { errorCodes } from '@ourbranch/lookups';

// The backend signals a retryable vehicle-lookup outage on the same INVALIDVIN/5010 code via the
// rater pipeline's structured bracket metadata (`... [5010][{"lookupUnavailable":true}]`, built in
// @ourbranch/vehicle-data-client buildVinLookupFailureError). The payload arrives on the store
// error's `data` (object or JSON string depending on the path); a real no-hit carries none.
export const isVinLookupUnavailable = (error) => {
  if (Number(error?.code) !== errorCodes.INVALIDVIN) {
    return false;
  }
  const payload = error?.data ?? error?.metadata;
  if (!payload) {
    return false;
  }
  try {
    const parsed = typeof payload === 'object' ? payload : JSON.parse(payload);
    return Boolean(parsed?.lookupUnavailable);
  } catch {
    return false;
  }
};
